const es = {
  meta: { code: "es", label: "Español" },
  nav: {
    brand: "IQ Log",
    diagnostics: "Evaluaciones",
    mypage: "Mi Página",
    login: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
  },
  hero: {
    eyebrow: "Plataforma de evaluación",
    title: "Descubre tu esencia mediante evaluaciones",
    subtitle1: "Pensamiento, personalidad y aptitud — totalmente visualizados",
    subtitle2: "Mira tus fortalezas y debilidades en 5 minutos",
    subtitle3: "Cada evaluación se convierte en tu dato",
    cta_primary: "Iniciar evaluación",
    cta_secondary: "Ver catálogo",
    disclaimer: "Información de referencia / No médica",
  },
  categories: {
    ability: "Habilidad",
    personality: "Personalidad",
    mental: "Mental",
    aptitude: "Aptitud",
    traits: "Rasgos",
  },
  catalog: {
    title: "Todas las evaluaciones",
    subtitle: "17 tests / 5 categorías",
    filter_all: "Todas",
    duration: "min",
    difficulty: { easy: "Fácil", medium: "Medio", hard: "Difícil" },
    question_count: "Preg",
    start: "Iniciar",
  },
  quiz: {
    question: "Pregunta",
    of: "/",
    next: "Siguiente",
    prev: "Atrás",
    submit: "Ver resultado",
    progress: "Progreso",
    exit: "Salir",
    required: "Selecciona una opción",
    submitting: "Calificando…",
  },
  result: {
    overall: "Puntaje total",
    type_label: "Tipo",
    share_link: "Compartir resultado con un enlace",
    back_to_catalog: "Hacer otra evaluación",
    view_mypage: "Ver historial en Mi Página",
    premium_title: "Desbloquea el análisis detallado",
    premium_subtitle: "Con premium, verás todo lo siguiente:",
    feature_breakdown: "Desglose detallado de puntaje",
    feature_cause: "Análisis de causa raíz",
    feature_plan: "Plan de mejora",
    feature_pdf: "Informe PDF (A4)",
    price: "¥980",
    price_note: "(Pago seguro vía Stripe)",
    price_free: "Gratis",
    price_free_note: "(Tiempo limitado · 100% gratis)",
    unlock_button: "Pagar con Stripe",
    unlock_button_free: "Desbloquear gratis",
    unlock_requires_auth: "Inicia sesión para desbloquear",
    unlock_save_first: "Guarda tu resultado con una cuenta primero",
    unlocking: "Redirigiendo a Stripe…",
    free_only_notice: "La versión gratuita solo muestra el puntaje total y tipo.",
    compliance_note:
      "Esta evaluación es solo información de referencia y no un diagnóstico médico. Evitamos lenguaje definitivo o alarmista.",
  },
  premium: {
    title: "Informe de análisis detallado",
    summary: "Resumen general",
    strengths: "Fortalezas",
    weaknesses: "Áreas de crecimiento",
    improvements: "Plan de mejora",
    dimensions: "Puntajes por dimensión",
    download_pdf: "Descargar PDF",
    pdf_soon: "Exportar PDF (próximamente)",
  },
  mypage: {
    title: "Mi Página",
    subtitle: "Tu historial, tendencias de puntaje e insignias",
    total: "Total de evaluaciones",
    average: "Puntaje promedio",
    premium_count: "Desbloqueado",
    categories_covered: "Categorías cubiertas",
    trend_title: "Tendencia de puntaje",
    history_title: "Historial",
    badges_title: "Insignias",
    unlock_3_title: "Desbloquear Análisis Compuesto",
    unlock_3_desc: "Haz {n} evaluación(es) más para desbloquear el análisis compuesto",
    unlocked: "Análisis compuesto desbloqueado",
    no_history: "Aún no hay evaluaciones — comienza la primera ahora.",
  },
  auth: {
    login_title: "Iniciar sesión",
    register_title: "Crear cuenta",
    email: "Correo",
    password: "Contraseña (mín. 6 caracteres)",
    name: "Nombre visible (opcional)",
    login_btn: "Iniciar sesión",
    register_btn: "Registrarse",
    go_register: "¿No tienes cuenta? Regístrate",
    go_login: "¿Ya tienes cuenta? Inicia sesión",
    anon_note: "Las evaluaciones son gratuitas y anónimas. La cuenta solo es necesaria para guardar resultados y desbloquear premium.",
    success_register: "Cuenta creada",
    success_login: "Sesión iniciada",
    consent_section: "Consentimiento",
    consent_required: "Acepta los elementos obligatorios",
    accept_terms_pre: "Acepto los",
    terms_link: "Términos del Servicio",
    accept_terms_post: "",
    accept_privacy_pre: "He leído la",
    privacy_link: "Política de Privacidad",
    accept_privacy_post: "y consiento el tratamiento de mis datos personales",
    accept_age: "Tengo 16 años o más (o cuento con el consentimiento de mi tutor legal)",
    accept_marketing: "Envíenme correos sobre nuevas evaluaciones y promociones",
    optional: "opcional",
  },
  landing: {
    status_online: "SISTEMA EN LÍNEA",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 TESTS",
    status_langs: "14 IDIOMAS",
    status_ai: "AI · ON",
    title_line1: "Descubre tu esencia",
    title_line2: "en 5 minutos.",
    trust_diagnostics: "EVALUACIONES",
    trust_languages: "IDIOMAS",
    trust_per_test: "POR TEST",
    hud_readout: "LECTURA PRINCIPAL",
    hud_score_unit: "/100 TOTAL",
    hud_band: "BANDA · GOLD",
    hud_dimensions: "DIMENSIONES",
    hud_dimensions_status: "3 / 3 ACTIVO",
    hud_syslog: "REGISTRO DEL SISTEMA",
    cat_eyebrow: "// CATEGORÍAS",
    cat_title_pre: "5 categorías · ",
    cat_title_highlight: "17 evaluaciones",
    view_all: "Ver todo",
    proto_eyebrow: "// PROTOCOLO",
    proto_title_pre: "Desbloquea tu esencia ",
    proto_title_highlight: "en 3 pasos.",
    step1_title: "Elige un test",
    step1_body: "Elige entre 17 tests. Inicio anónimo.",
    step2_title: "Responde en 5 min",
    step2_body: "Barra de progreso e insignias te motivan.",
    step3_title: "Desbloquea con IA",
    step3_body: "Puntaje detallado, plan y PDF.",
    final_eyebrow: "// ¿LISTO?",
    final_title_pre: "Tu esencia ",
    final_title_highlight: "en 5 min.",
    final_subtitle: "Mira tus fortalezas y debilidades en 5 minutos",
    final_button: "Comenzar evaluación",
  },
  footer: {
    tagline: "Plataforma de evaluación para tu pensamiento, personalidad y aptitud",
    rights: "Todos los derechos reservados.",
    legal: "Legal",
    privacy: "Privacidad",
    terms: "Términos",
    about_label: "Acerca / Empresa",
    compliance_label: "Cumplimiento Internacional",
    tokushoho_label: "Ley Comercial de Japón",
    data_protection_label: "Protección de Datos (Internacional)",
    data_request_label: "Eliminar Datos / Opt-out",
    disclaimer_label: "Aviso Legal",
    disclaimer_full:
      "Este servicio es solo de referencia y no un diagnóstico médico. No usamos lenguaje definitivo ni alarmista.",
  },
  badges: {
    "first-diagnosis": "Primera evaluación",
    "three-diagnostics": "3 evaluaciones",
    "five-diagnostics": "5 evaluaciones",
    "ten-diagnostics": "10 evaluaciones",
    "high-performer": "Alto desempeño",
    "premium-user": "Usuario premium",
  },
  lang_selector: "Idioma",
  payment: {
    processing_title: "Verificando pago…",
    processing_subtitle: "Regresado de Stripe — generando análisis detallado (hasta 20s)",
    success: "Pago confirmado — premium desbloqueado",
    expired: "Sesión de pago caducada. Inténtalo de nuevo.",
    error: "No se pudo verificar el pago. Contacta al soporte.",
  },
};
export default es;
